module.exports = __webpack_public_path__ + "img/f1-2.00b71a64.png";